export const SEO_COMMON = {
  TITLE: process.env.VUE_APP_SEO_DEFAULT_TITLE ?? 'Trade BLUES and farm',
  DESCRIPTION:
    process.env.VUE_APP_SEO_DEFAULT_DESCRIPTION ??
    'Dive into crypto with Blueshift. Get rewarded for your trades!',
  KEYWORDS:
    process.env.VUE_APP_SEO_DEFAULT_KEYWORDS ??
    'airdrop, testnet, giveaway, retrodrop, farming, apr, L2 network, DeFi, Blueshift, trade, yield farming, $BLUES',
};

export const SEO_SWAP = {
  TITLE: SEO_COMMON.TITLE,
  DESCRIPTION: SEO_COMMON.DESCRIPTION,
  KEYWORDS: SEO_COMMON.KEYWORDS,
};

export const SEO_PORTFOLIOS = {
  TITLE: SEO_COMMON.TITLE,
  DESCRIPTION: SEO_COMMON.DESCRIPTION,
  KEYWORDS: SEO_COMMON.KEYWORDS,
};

export const SEO_PAIRS = {
  TITLE: SEO_COMMON.TITLE,
  DESCRIPTION: SEO_COMMON.DESCRIPTION,
  KEYWORDS: SEO_COMMON.KEYWORDS,
};

export const SEO_FARMING = {
  TITLE: SEO_COMMON.TITLE,
  DESCRIPTION: SEO_COMMON.DESCRIPTION,
  KEYWORDS: SEO_COMMON.KEYWORDS,
};

export const SEO_STAKING = {
  TITLE: SEO_COMMON.TITLE,
  DESCRIPTION: SEO_COMMON.DESCRIPTION,
  KEYWORDS: SEO_COMMON.KEYWORDS,
};

export const SEO_BRIDGE = {
  TITLE: SEO_COMMON.TITLE,
  DESCRIPTION: SEO_COMMON.DESCRIPTION,
  KEYWORDS: SEO_COMMON.KEYWORDS,
};

export const PREVIEW_IMAGE = 'https://app.blueshift.fi/blueshift-splash.png';

export const SEO_META_OG = {
  OG_TITLE: SEO_COMMON.TITLE,
  OG_SITE_NAME: SEO_COMMON.TITLE,
  OG_TYPE: 'website',
  OG_DESCRIPTION: SEO_COMMON.DESCRIPTION,
  OG_IMAGE: PREVIEW_IMAGE,
};

export const SEO_META_TWITTER = {
  TWITTER_CARD: 'summary',
  TWITTER_TITLE: SEO_COMMON.TITLE,
  TWITTER_DESCRIPTION: SEO_COMMON.DESCRIPTION,
  PREVIEW_IMAGE: PREVIEW_IMAGE,
};
